import {Component, React, observer, resolveCss} from '$src/handy'
import Switch from 'react-switch'
import * as css from './PriceSwitch.css'
import {HousingCorporation} from '$src/bootstrap/Store'
import editHousingCorporationSummaryAdjusted from '$src/api/endpoints/housingCorporations/editHousingCorporationSummaryAdjusted'

interface Props {
  housingCorporation: typeof HousingCorporation.Type
}

interface State {
  submitting: boolean
  optimisticState: null | boolean
}

const classes = resolveCss(css, {})

@observer
export default class PriceSwitch extends Component<Props, State> {
  constructor(props: Props, context: any) {
    super(props, context)
    this.state = {
      submitting: false,
      optimisticState: null,
    }
  }

  toggle = async () => {
    const {props, state} = this

    if (state.submitting) return

    const summaryAdjusted = !props.housingCorporation.isSummaryAdjusted()
    this.setState({submitting: true, optimisticState: summaryAdjusted})

    try {
      await this.callEndpoint(editHousingCorporationSummaryAdjusted, {
        cid: props.housingCorporation._id,
        adjusted: summaryAdjusted,
      })
    } catch (e) {
      this.setState({
        submitting: false,
        optimisticState: null,
      })

      console.log('Error editing Adjusted state')
      console.log(e)
      return
    }

    this.setState({
      submitting: false,
      optimisticState: null,
    })

    props.housingCorporation.toggleSummary()
  }

  render() {
    const {props} = this
    const checked = props.housingCorporation.isSummaryAdjusted()

    return (
      <div {...classes('container')}>
        <label>
          <span>Actual price</span>
          <Switch
            onChange={this.toggle}
            checked={checked}
            onColor="var(--color-brand)"
            onHandleColor="var(--color-brand)"
            handleDiameter={20}
            uncheckedIcon={false}
            checkedIcon={false}
            boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
            activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
            height={15}
            width={32}
            className="price-switch"
            id="priceSelector"
          />
          <span>Index adjusted</span>
        </label>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/comparableSales/PriceSwitch.tsx